import { ReadonlyURLSearchParams } from "next/navigation";

export function getAnalytics(query: ReadonlyURLSearchParams) {
  return {
    utm_source: query.get("utm_source") || 'Direto',
    utm_medium: query.get("utm_medium") || 'Direto',
    utm_campaign: query.get("utm_campaign") || 'Direto',
  };
}
